// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"frame"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 21L21 21L21 3L12 3L3 3L3 21H12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 21H21V3H12M12 21H3V3H12M12 21V3M3 12H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FrameIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'frame',
    ref,
    icon: element,
  },
));

FrameIcon.displayName = 'FrameIcon';

export default FrameIcon;
